import gql from 'graphql-tag.macro'

export const getDrupalContext = gql`
  query ($citrixId: String) {
    userQuery(
      filter: {
        conditions: [{operator: EQUAL, field: "name", value: [$citrixId]}]
      }
    ) {
      entities {
        ... on User {
          uid
        }
      }
    }
  }
`
export const getUserRoleByCitrixId = gql`
  query ($citrixId: String) {
    userQuery(
      filter: {
        conditions: [{operator: EQUAL, field: "name", value: [$citrixId]}]
      }
    ) {
      entities {
        ... on User {
          uid
          roles {
            targetId
          }
        }
      }
    }
  }
`

export const getEmployeeDetailsFromIAM = gql`
  query ($empId: String) {
    getEmployeeDetailsFromIAM(empId: $empId) {
      firstName
      lastName
      displayName
      jobTitle
      costCenterCode
      costCenterName
      email
      legalEntityName
      streetAddress
      city
      country
      workMobile
      personalId
      sixtId
      externalEmail
      usageLocation
      countryCode
      isFormerEmployee
      zipCode
    }
  }
`
export const currentUserRolesQuery = gql`
  query {
    currentUserContext {
      roles {
        targetId
      }
    }
  }
`
